<template>
  <div id="outmost-wrapper" class="bg-white">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import '@vant/touch-emulator'
import { enableBoundaryChecking } from 'number-precision'
import { useSharedStore } from './stores/shared'
import { pxToClampVw, isAllScreenDisplay } from './utils'
import { isInWechat, isInQQ } from './utils/device'
import native, { isInApp } from './utils/native'

const envConfig = useRuntimeConfig()
const router = useRouter()
const sharedStore = useSharedStore()
const { appEnv } = useRuntimeConfig().public

enableBoundaryChecking(false)

watch(
  () => router.currentRoute.value,
  newVal => {
    // TODO: 当前这部分逻辑仅仅针对存在底部导航栏的情况，但事实上所有iphone全面屏手机都有这个问题，因此需要优化
    sharedStore.isShowBottomNavigation = newVal.path === '/' || newVal.path === '/recharge' || newVal.path === '/pay'
    sharedStore.isShowBottomSafeArea = sharedStore.isShowBottomNavigation && isAllScreenDisplay() && (isInWechat() || isInQQ() || isInApp)
    sharedStore.BOTTOM_HEIGHT = 50
    sharedStore.LAYOUT_PADDING_BOTTOM =
      sharedStore.isShowBottomNavigation && sharedStore.isShowBottomSafeArea
        ? pxToClampVw(sharedStore.BOTTOM_HEIGHT + sharedStore.BOTTOM_SAFE_AREA_HEIGHT)
        : pxToClampVw(50)
  }
)

// const result = await useAsyncData('name', async () => {
//   const res = await axiosGetLuckyRules()
//   console.log(res)
//   return res?.data
// })

onMounted(() => {
  sharedStore.setOrigin(window.location.origin)

  if (appEnv === 'prod') {
    const script = document.createElement('script')
    script.src = 'https://hm.baidu.com/hm.js?8dbd4edb4eb950382c434cedb6db50d6'
    document.head.appendChild(script)
  }

  sharedStore.isShowBottomNavigation =
    router.currentRoute.value.path === '/' || router.currentRoute.value.path === '/recharge' || router.currentRoute.value.path === '/pay'
  sharedStore.isShowBottomSafeArea = sharedStore.isShowBottomNavigation && isAllScreenDisplay() && (isInWechat() || isInQQ() || isInApp)
  sharedStore.BOTTOM_HEIGHT = 50
  sharedStore.LAYOUT_PADDING_BOTTOM =
    sharedStore.isShowBottomNavigation && sharedStore.isShowBottomSafeArea
      ? pxToClampVw(sharedStore.BOTTOM_HEIGHT + sharedStore.BOTTOM_SAFE_AREA_HEIGHT)
      : pxToClampVw(50)

  window.addEventListener('message', event => {
    if (event.origin === envConfig.public.catUrl) {
      console.log(event)
      if (typeof event.data !== 'string') {
        return
      }
      const info = JSON.parse(event?.data || '')
      if (info.from === 'recharge') {
        if (info.message === 'PAY_SUCCESS') {
          // showToast('兑换成功')
        }
        setTimeout(() => {
          if (info.origin.includes('lucky/detail')) {
            // 从饰品详情跳转到充值，充值成功后调用back
            if (isInApp) {
              native?.back()
            } else {
              const url = new URL(info.origin)
              router.replace(`/lucky/detail?id=${url.searchParams.get('id')}`)
            }
          } else {
            // 从底部tab进入充值，充值完成后直接跳转回首页
            router.replace('/')
          }
        }, 1000)
      }
    }
  })
})
</script>

<style lang="scss">
/* 由于 vant 中的主题变量也是在 :root 下声明的，所以在有些情况下会由于优先级的问题无法成功覆盖。
通过 :root:root 可以显式地让你所写内容的优先级更高一些，从而确保主题变量的成功覆盖 */
:root:root {
  --van-button-mini-height: 24px;
  --van-button-mini-padding: 0 10px;
  --van-button-mini-font-size: 12px;
  --van-button-small-height: 28px;
  --van-button-small-padding: 0 7px;
  --van-button-small-font-size: 13px;
  --van-button-normal-font-size: 15px;
  --van-button-normal-padding: 0 8px;
  --van-button-default-height: 37px;
  --van-button-large-height: 40px;
  --van-button-default-color: #888;
  --van-button-default-border-color: #888;
  --van-primary-color: #fd802c;
  --van-action-sheet-header-font-size: 17px;
  --van-action-sheet-header-height: 1;
  --van-empty-description-margin-top: -15px; // 设计稿中默认文字在图片内部
}

:root {
  .van-action-sheet__header {
    color: #150000;
    font-weight: 500;
    padding: 20px 0 12px;
    .van-action-sheet__close {
      padding: 15px;
    }
  }
}

* {
  border: 0 solid theme('colors.grey.702');
  // border: 0;
  outline: none;
  padding: 0;
  margin: 0;
}

html {
  height: 100%;
  margin: 0 auto;
}

body {
  // height: 100%;
  background-color: rgb(243, 244, 245);
}

// postcss-mobile-forever会自动注入居中、最大宽度的样式
#outmost-wrapper {
  transform: scale3d(1, 1, 1); // 使后代所有 position:fixed 定位的元素以该元素为基准
  overflow-y: hidden;
  overflow-x: hidden;
}

::-webkit-scrollbar {
  background-color: transparent;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
  background-clip: content-box;
  border: 1px solid transparent;
}

// vue transitions
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
